import { width } from "@mui/system";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { CgClose } from "react-icons/cg";
import { FiChevronDown } from "react-icons/fi";
import { TbCheck } from "react-icons/tb";
import { useDispatch, useSelector } from "react-redux";
import {
  commissionEditReducerSlice,
  commissionReducerSlice
} from "../../../../data/redux/slice/commissionSlice";
import secureStorage from "../../../../services/secureStorage";
import {
  Approve,
  DownloadIcon,
  EditAltIcon,
  Eyelight,
  InfoTextIcon,
  Reject
} from "../../../../utility/constants/assetsManager";
import {
  colorDarkGreen,
  colorDarkRed,
  colorDarkYellow,
  colorLightGreen,
  colorLightRed,
  colorLightYellow,
  primaryColor
} from "../../../../utility/constants/colorManager";
import {
  SS_INTERNAL,
  SS_ROLE
} from "../../../../utility/constants/secureStorageManager";
import {
  ACTIVE,
  ADMIN,
  ADMIN_USER,
  APPROVAL_LIST,
  CLIENT,
  CLIENTS_DEACTIVATE_ACCOUNT_ACL,
  CUSTOMER_STATUS_EDIT,
  INACTIVE,
  PENDING,
  RESELLER_DEACTIVATE_ACL,
  RNC,
  ROLE_Deactivate_ACL,
  SALES,
  TRANSACTION_CREDIT,
  TRANSACTION_CREDITED,
  TRANSACTION_DEBITED,
  TRANSACTION_FAILED
} from "../../../../utility/constants/valueConstants";
import { formatBalance } from "../../../../utility/moneyFormatter";
import ResizeListner from "../../../../utility/ResizeListner";
import { getAllServiceName } from "../../ui_comps/approval_comps/ApprovalContainer";
import CommissionEditComponent from "../../ui_comps/CommissionEditComponent";
import { CustomLoader } from "../custom_loader";
import ToggleSwitch from "../custom_toggle_switch";
import Pagination from "./Paginations/Pagination";
import "./table.css";
import { saveAs } from "file-saver";
import CustomSelect from "../custom_select";
import { CustomInput } from "../custom_input/CustomInput";

const CustomTable = ({
  totalElements = 0,
  handlePaginate,
  totalPages = 0,
  data = [],
  headers,
  onViewMore,
  onStatusChange = () => {},
  styles,
  onClickReject,
  onClickAccept,
  loading1,
  onViewMoreCommission = () => {},
  isCommissionList = false,
  emptyDataMessage = "No records found!",
  currentPage = 0,
  onActionClicked = () => {},
  handleInputChange = () => {},
  onQrCreate
}) => {
  const { height } = ResizeListner();
  const [indexing, setIndexing] = useState(0);
  const [roleApproval, setRoleApproval] = useState("");
  const editCommission = useSelector((state) => state.commissionSlice);
  const isTableLoading = useSelector(
    (state) => state.loaderSlice.isTableLoading
  );
  const aclData = useSelector((state) => state.aclSlice.aclList);
  const role = secureStorage.getItem(SS_ROLE);
  const internal = secureStorage.getItem(SS_INTERNAL);
  const clientSecret = useSelector((state) => state.listingSlice.clientDetails);

  const options = [
    {
      label: "Action needed",
      value: ""
    },
    {
      label: "Approve",
      value: "approve"
    },
    {
      label: "Reject",
      value: "reject"
    }
  ];

  const [selectedOptions, setSelectedOptions] = useState({});

  const dispatch = useDispatch();

  const getAllServiceProviderRate = (res) => {
    let str = "";
    res?.map((data, i) => {
      if (i === 0) {
        str = data?.serviceProviderRate + "%";
      } else str = str + ", " + data?.serviceProviderRate + "%";
    });
    return str;
  };

  return (
    <div
      style={{
        maxHeight: height * 0.75,
        overflow: "auto",
        position: "relative",
        minHeight: height * 0.75,
        display: "flex",
        justifyContent: "space-between",
        flexDirection: "column",
        borderBottomLeftRadius: 10,
        borderBottomRightRadius: 10,
        ...styles
      }}
    >
      <table className="rwd-table">
        <thead className="rwd-table-body">
          <tr>
            {headers &&
              headers.map((header, index) => {
                return (
                  <th
                    style={{
                      position: "sticky",
                      top: 0,
                      minWidth: header.key === "slno" && "80px",
                      maxWidth: header.key === "slno" && "80px",
                      width: header.key === "slno" && "80px"
                    }}
                    key={index}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        width: header.key === "mainAction" && "fit-content",
                        margin: header.key === "mainAction" && "auto"
                      }}
                    >
                      <p>{header.title}</p>
                      {header?.tooltip ? (
                        <div
                          className="tooltip"
                          style={{ display: "flex", alignItems: "center" }}
                        >
                          <InfoTextIcon
                            style={{ width: "20px", height: "20px" }}
                            className="tooltip"
                          />
                          <span className="tooltiptext">
                            {header?.tooltipName}
                          </span>
                        </div>
                      ) : null}
                    </div>
                  </th>
                );
              })}
          </tr>
        </thead>

        <tbody className="rwd-table-body">
          {!isTableLoading &&
            data?.length !== 0 &&
            data?.map((row, i) => (
              <tr key={i}>
                {headers.map((header, index) =>
                  header.key === "InvoicetransferUniqueNo" ? (
                    <td key={index} data-th={header.title} style={{}}>
                      <p>{row["transactions"]?.txnId}</p>
                    </td>
                  ) : header.key === "slno" ? (
                    <td
                      key={index}
                      data-th={header.title}
                      style={{
                        width: "20px",
                        minWidth: "20px",
                        maxWidth: "20px"
                      }}
                    >
                      {(i + 1) % 10 === 0
                        ? (indexing + 1) * 10
                        : parseInt(indexing) + 1 &&
                          indexing.toString() + (i + 1).toString()}
                    </td>
                  ) : header.key === "customerName" ? (
                    <td
                      key={index}
                      data-th={header.title}
                      style={{
                        width: "20px",
                        minWidth: "20px",
                        // maxWidth: "0px",
                        marginRight: 20
                      }}
                    >
                      {row["beneFullName"]}
                    </td>
                  ) : header.key === "customerNameRisk" ? (
                    <td
                      key={index}
                      data-th={header.title}
                      style={
                        {
                          // width: "20px",
                          // minWidth: "20px",
                          // // maxWidth: "0px",
                          // marginRight: 20,
                        }
                      }
                    >
                      {row["customerName" ?? "N/A"]}
                    </td>
                  ) : header.key === "mobileNumberRisk" ? (
                    <td key={index} data-th={header.title} style={{}}>
                      {row["mobileNumber" ?? "N/A"]}
                    </td>
                  ) : header.key === "transactionClientName" ? (
                    <td
                      key={index}
                      data-th={header.title}
                      style={{
                        width: "20px",
                        minWidth: "20px",
                        // maxWidth: "0px",
                        marginRight: 20
                      }}
                    >
                      {row["customerInfo"]?.customerName
                        ? row["customerInfo"]?.customerName
                        : "N/A"}
                    </td>
                  ) : header.key === "vanAccNumber" ? (
                    <td
                      key={index}
                      data-th={header.title}
                      style={{
                        minWidth: "200px"
                      }}
                    >
                      {row["vanAccNumber"] ?? "N/A"}
                    </td>
                  ) : header.key === "customerNameVan" ? (
                    <td
                      key={index}
                      data-th={header.title}
                      style={{
                        width: "200px",
                        minWidth: "200px",
                        maxWidth: "200px"
                      }}
                    >
                      {row["firstName"] +
                        " " +
                        row["middleName"] +
                        " " +
                        row["lastName"] ?? "N/A"}
                    </td>
                  ) : header.key === "pan_number" ? (
                    <td
                      key={index}
                      data-th={header.title}
                      style={{
                        width: "200px",
                        minWidth: "200px",
                        maxWidth: "200px"
                      }}
                    >
                      {row["pan_number"] ?? "N/A"}
                    </td>
                  ) : header.key === "rmtrAccNum" ? (
                    <td
                      key={index}
                      data-th={header.title}
                      style={{
                        minWidth: "200px"
                      }}
                    >
                      {row["customerAccountDetails"]?.[0]?.accountNumber ??
                        "N/A"}
                    </td>
                  ) : header.key === "beneAccountNo" ? (
                    <td
                      key={index}
                      data-th={header.title}
                      style={{
                        width: "20px",
                        minWidth: "20px"
                        // maxWidth: "20px",
                      }}
                    >
                      {row["beneAccountNo"] ??
                        row["prefundAccountNumber"] ??
                        "N/A"}
                    </td>
                  ) : header.key === "transferUniqueNo" ? (
                    <td
                      key={index}
                      data-th={header.title}
                      style={{
                        width: "20px",
                        minWidth: "20px"
                        // maxWidth: "20px",
                      }}
                    >
                      {row["transferUniqueNo"] ?? "N/A"}
                    </td>
                  ) : header.key === "upi" ? (
                    <td
                      key={index}
                      data-th={header.title}
                      style={{
                        width: "20px",
                        minWidth: "20px"
                        // maxWidth: "20px",
                      }}
                    >
                      {row["van_upi_id"] ?? "N/A"}
                    </td>
                  ) : header.key === "mobileNumber" ? (
                    <td
                      key={index}
                      data-th={header.title}
                      style={{
                        width: "100px",
                        minWidth: "100px",
                        maxWidth: "100px"
                      }}
                    >
                      {row["mobileNumber"] ?? "N/A"}
                    </td>
                  ) : header.key === "customerMobileNumber" ? (
                    <td
                      key={index}
                      data-th={header.title}
                      style={{
                        width: "100px",
                        minWidth: "100px",
                        maxWidth: "100px"
                      }}
                    >
                      {row["mobile_number"] ?? "N/A"}
                    </td>
                  ) : header.key === "van_upi_id" ? (
                    <td
                      key={index}
                      data-th={header.title}
                      style={{
                        width: "auto"
                      }}
                    >
                      {row["van_upi_id"] ?? "N/A"}
                    </td>
                  ) : header.key === "customerListStatus" ? (
                    <td key={index} data-th={header.title} style={{}}>
                      <p
                        key={index}
                        data-th={header.title}
                        style={{
                          background: row["status"]
                            ? "rgba(63, 169, 47, 0.1)"
                            : "rgba(231, 66, 66, 0.1)",
                          color: row["status"] ? "#3FA92F" : "#E74242",
                          borderRadius: "4px",
                          fontSize: "14px",
                          width: "75px",
                          height: 30,
                          justifyContent: "center",
                          alignItems: "center",
                          display: "flex"
                        }}
                      >
                        {row["status"] === true ? "Active" : "In-Active"}
                      </p>
                    </td>
                  ) : header.key === "status" ? (
                    <td key={index} data-th={header.title} style={{}}>
                      <p
                        key={index}
                        data-th={header.title}
                        style={{
                          background:
                            row["status"] === true
                              ? "rgba(63, 169, 47, 0.1)"
                              : "rgba(231, 66, 66, 0.1)",
                          color: row["status"] === true ? "#3FA92F" : "#E74242",
                          borderRadius: "4px",
                          fontSize: "14px",
                          width: "75px",
                          height: 30,
                          justifyContent: "center",
                          alignItems: "center",
                          display: "flex"
                        }}
                      >
                        {row["status"] === true ? "Active" : "In-Active"}
                      </p>
                    </td>
                  ) : header.key === "customerListBusinessName" ? (
                    <td
                      key={index}
                      data-th={header.title}
                      style={{
                        width: "170px",
                        minWidth: "170px",
                        maxWidth: "170px"
                      }}
                    >
                      {row["clients"]?.businessName ?? "N/A"}
                    </td>
                  ) : header.key === "transferId" ? (
                    <td key={index} data-th={header.title} style={{}}>
                      {row["transferId"]
                        ? row["transferId"]
                        : row["transferId"] ?? "N/A"}
                    </td>
                  ) : header.key === "payoutTransferId" ? (
                    <td key={index} data-th={header.title} style={{}}>
                      {row["transferId"] ?? "N/A"}
                    </td>
                  ) : header.key === "transferType" ? (
                    <td
                      key={index}
                      data-th={header.title}
                      style={{
                        width: "20px",
                        minWidth: "20px",
                        maxWidth: "20px"
                      }}
                    >
                      {row[header.key] ?? "N/A"}
                    </td>
                  ) : header.key === "chargeBackHold" ? (
                    <td
                      key={index}
                      data-th={header.title}
                      style={{
                        width: "20px",
                        minWidth: "20px",
                        maxWidth: "20px"
                      }}
                      contenteditable="true"
                    >
                      <input
                        style={{
                          boxShadow: "0.1px 0.1px 0.5px 1px white",
                          borderRadius: 1,
                          fontSize: 12,
                          color: "black",
                          height: 38,
                          outline: "none",
                          paddingTop: 3,
                          paddingBottom: 3
                        }}
                        type="number"
                        vaidator={"number"}
                        value={row[header.key] || ""}
                        placeholder="0"
                        onChange={(e) => {
                          console.log(
                            e,
                            row.userId,
                            header.key,
                            "---CustomInput->>>"
                          );

                          handleInputChange(e, row.userId, header.key);
                        }}
                      />
                    </td>
                  ) : header.key === "chargeBackRelease" ? (
                    <td
                      key={index}
                      data-th={header.title}
                      style={{
                        width: "20px",
                        minWidth: "20px",
                        maxWidth: "20px"
                      }}
                      contenteditable="true"
                    >
                      {/* {row[header.key] ?? "N/A"} */}
                      {/* <CustomInput
                            type="number"
                            placeholder="N/A"
                            value={row[header.key] || ''}
                            onChange={(e) => {

                              console.log(e, "---CustomInput->>>")

                              handleInputChange(e, row._id, header.key)
                            }}
                            style={{ width: "100%", backgroundColor: "#F3F3F3", padding: "5px" }}
                          /> */}

                      <input
                        style={{
                          boxShadow: "0.1px 0.1px 0.5px 1px white",
                          borderRadius: 1,
                          fontSize: 12,
                          color: "black",
                          height: 38,
                          outline: "none",
                          paddingTop: 3,
                          paddingBottom: 3
                        }}
                        type="number"
                        vaidator={"number"}
                        value={row[header.key] || ""}
                        placeholder="0"
                        onChange={(e) => {
                          console.log(
                            e,
                            row.userId,
                            header.key,
                            "---CustomInput->>>"
                          );

                          handleInputChange(e, row.userId, header.key);
                        }}
                      />
                    </td>
                  ) : header.key === "businessName" ? (
                    <td
                      key={index}
                      data-th={header.title}
                      style={{
                        width: "auto"
                      }}
                    >
                      {row["businessName"] ?? "N/A"}
                    </td>
                  ) : header.key === "client_name" ? (
                    <td
                      key={index}
                      data-th={header.title}
                      style={{
                        width: "auto"
                      }}
                    >
                      {row["client_name"] ?? "N/A"}
                    </td>
                  ) : header.key === "van_account_number" ? (
                    <td
                      key={index}
                      data-th={header.title}
                      style={{
                        width: "auto"
                      }}
                    >
                      {row["van_account_number"] ?? "N/A"}
                    </td>
                  ) : header.key === "vanCustomerName" ? (
                    <td
                      key={index}
                      data-th={header.title}
                      style={{
                        width: "auto"
                      }}
                    >
                      {row["first_name"] + " " + row["last_name"] ?? "N/A"}
                    </td>
                  ) : header.key === "first_name" ? (
                    <td
                      key={index}
                      data-th={header.title}
                      style={{
                        width: "auto"
                      }}
                    >
                      {row["first_name"] + " " + row["last_name"] ?? "N/A"}
                    </td>
                  ) : header.key === "businessNameVan" ? (
                    <td
                      key={index}
                      data-th={header.title}
                      style={{
                        width: "20px",
                        minWidth: "20px",
                        maxWidth: "20px"
                      }}
                    >
                      {row["clients"]?.businessName ?? "N/A"}
                    </td>
                  ) : header.key === "transferAmt" ? (
                    <td key={index} data-th={header.title}>
                      <p>{row["transferAmt"] / 100 ?? "N/A"}</p>
                    </td>
                  ) : header.key === "chargeBack" ? (
                    <td key={index} data-th={header.title}>
                      <p>
                        {"₹" +
                          (row["chargeBack"] ? row["chargeBack"] / 100 : 0)}
                      </p>
                    </td>
                  ) : header.key === "chargeRelease" ? (
                    <td key={index} data-th={header.title}>
                      <p>
                        {"₹" +
                          (row["chargeBackRelease"]
                            ? row["chargeBackRelease"] / 100
                            : 0)}
                      </p>
                    </td>
                  ) : header.key === "transactionHashId" ? (
                    <td key={index} data-th={header.title}>
                      <p>{row["transactionHashId"] ?? "N/A"}</p>
                    </td>
                  ) : header.key === "businessName" ? (
                    <td key={index} data-th={header.title}>
                      {row[header.key] ? row[header.key] : "N/A"}
                    </td>
                  ) : header.key === "reason" ? (
                    <td key={index} data-th={header.title}>
                      <p>{row["rncrejectedBy"]?.reason ?? "N/A"}</p>
                    </td>
                  ) : header.key === "serviceRate" ? (
                    <td key={index} data-th={header.title}>
                      <div
                        className="tooltip"
                        style={{
                          display: "flex",

                          gap: 3
                        }}
                      >
                        <p style={{ textTransform: "capitalize" }}>
                          {row["service"][0]?.comissionType}
                        </p>
                        <InfoTextIcon
                          style={{ width: "20px", height: "20px" }}
                          className="tooltip"
                        />
                      </div>
                    </td>
                  ) : header.key === "txnStatus" ? (
                    <td key={index} data-th={header.title} style={{}}>
                      <p
                        style={{
                          background:
                            row["status"] === "CREDITED" ||
                            row["status"] === "DEBITED" ||
                            row["status"] === "REFUNDED" ||
                            row["status"] === "CREDIT" ||
                            row["status"] === "SUCCESS" ||
                            row["status"] === "DEEMED" ||
                            row["status"] === "CREDIT_CONFIRMATION"
                              ? "rgba(63, 169, 47, 0.1)"
                              : row["status"] === "INITIATED"
                              ? colorLightYellow
                              : "rgba(231, 66, 66, 0.1)",
                          color:
                            row["status"] === "CREDITED" ||
                            row["status"] === "DEBITED" ||
                            row["status"] === "REFUNDED" ||
                            row["status"] === "CREDIT" ||
                            row["status"] === "SUCCESS" ||
                            row["status"] === "DEEMED" ||
                            row["status"] === "CREDIT_CONFIRMATION"
                              ? "#3FA92F"
                              : row["status"] === "INITIATED"
                              ? colorDarkYellow
                              : "#E74242",
                          borderRadius: "4px",
                          fontSize: "14px",
                          width: "75px",
                          height: 30,
                          justifyContent: "center",
                          alignItems: "center",
                          display: "flex"
                        }}
                      >
                        {row["status"] === "CREDITED" ||
                        row["status"] === "DEBITED" ||
                        row["status"] === "CREDIT" ||
                        row["status"] === "REFUNDED" ||
                        row["status"] === "CREDIT_CONFIRMATION"
                          ? "Success"
                          : row["status"] === "INITIATED"
                          ? "Initiated"
                          : row["status"] === "REJECTED"
                          ? "Rejected"
                          : row["status"] === "PENDING"
                          ? "Pending"
                          : row["status"] === "SUCCESS"
                          ? "Success"
                          : row["status"] === "RETURNED"
                          ? "Returned"
                          : row["status"] === "REVERSED"
                          ? "Reversed"
                          : row["status"] === "DEEMED"
                          ? "Deemed"
                          : "Failed"}
                      </p>
                    </td>
                  ) : header.key === "txn_status" ? (
                    <td key={index} data-th={header.title} style={{}}>
                      <p
                        style={{
                          background:
                            row["txn_status"] === "CREDITED" ||
                            row["txn_status"] === "DEBITED" ||
                            row["txn_status"] === "REFUNDED" ||
                            row["txn_status"] === "CREDIT" ||
                            row["txn_status"] === "SUCCESS" ||
                            row["txn_status"] === "DEEMED"
                              ? "rgba(63, 169, 47, 0.1)"
                              : row["txn_status"] === "INITIATED"
                              ? colorLightYellow
                              : "rgba(231, 66, 66, 0.1)",
                          color:
                            row["txn_status"] === "CREDITED" ||
                            row["txn_status"] === "DEBITED" ||
                            row["txn_status"] === "REFUNDED" ||
                            row["txn_status"] === "CREDIT" ||
                            row["txn_status"] === "SUCCESS" ||
                            row["txn_status"] === "DEEMED"
                              ? "#3FA92F"
                              : row["txn_status"] === "INITIATED"
                              ? colorDarkYellow
                              : "#E74242",
                          borderRadius: "4px",
                          fontSize: "14px",
                          width: "75px",
                          height: 30,
                          justifyContent: "center",
                          alignItems: "center",
                          display: "flex"
                        }}
                      >
                        {row["txn_status"] === "CREDITED" ||
                        row["txn_status"] === "DEBITED" ||
                        row["txn_status"] === "CREDIT" ||
                        row["txn_status"] === "REFUNDED"
                          ? "Success"
                          : row["txn_status"] === "INITIATED"
                          ? "Initiated"
                          : row["txn_status"] === "REJECTED"
                          ? "Rejected"
                          : row["txn_status"] === "PENDING"
                          ? "Pending"
                          : row["txn_status"] === "SUCCESS"
                          ? "Success"
                          : row["txn_status"] === "RETURNED"
                          ? "Returned"
                          : row["txn_status"] === "DEEMED"
                          ? "Deemed"
                          : "Failed"}
                      </p>
                    </td>
                  ) : header.key === "payoutStatus" ? (
                    <td key={index} data-th={header.title} style={{}}>
                      <p
                        style={{
                          background:
                            row["status"] === "TRANSFER_SUCCESS" ||
                            row["status"] === "CREDIT_CONFIRMATION" ||
                            row["status"] === "TRANSFER_ACKNOWLEDGED" ||
                            row["status"] === "SUCCESS" ||
                            row["status"] === "PREFUND"
                              ? "rgba(63, 169, 47, 0.1)"
                              : row["status"] === "INITIATED" ||
                                row["status"] === "RECEIVED" ||
                                row["status"] === "INPROGRESS" ||
                                row["status"] === "PENDING"
                              ? colorLightYellow
                              : "rgba(231, 66, 66, 0.1)",
                          color:
                            row["status"] === "TRANSFER_SUCCESS" ||
                            row["status"] === "CREDIT_CONFIRMATION" ||
                            row["status"] === "TRANSFER_ACKNOWLEDGED" ||
                            row["status"] === "SUCCESS" ||
                            row["status"] === "PREFUND"
                              ? "#3FA92F"
                              : row["status"] === "INITIATED" ||
                                row["status"] === "RECEIVED" ||
                                row["status"] === "INPROGRESS" ||
                                row["status"] === "PENDING"
                              ? colorDarkYellow
                              : "#E74242",
                          borderRadius: "4px",
                          fontSize: "14px",
                          width: "75px",
                          height: 30,
                          justifyContent: "center",
                          alignItems: "center",
                          display: "flex"
                        }}
                      >
                        {row["status"] === "TRANSFER_SUCCESS" ||
                        row["status"] === "CREDIT_CONFIRMATION" ||
                        row["status"] === "TRANSFER_ACKNOWLEDGED" ||
                        row["status"] === "PREFUND" ||
                        row["status"] === "SUCCESS"
                          ? "Success"
                          : row["status"] === "INITIATED" ||
                            row["status"] === "RECEIVED" ||
                            row["status"] === "INPROGRESS" ||
                            row["status"] === "PENDING"
                          ? "Initiated"
                          : "Failed"}
                      </p>
                    </td>
                  ) : header.key === "spr" ? (
                    <td key={index} data-th={header.title} style={{}}>
                      {editCommission.edit &&
                      editCommission.currentIndex === i ? (
                        <CommissionEditComponent
                          onChange={(val) =>
                            dispatch(
                              commissionEditReducerSlice({
                                spr: val,
                                nkrate: editCommission?.nkrate,
                                resellerRate: editCommission?.resellerRate,
                                totalRate: editCommission?.totalRate
                              })
                            )
                          }
                          value={editCommission?.spr}
                        />
                      ) : (
                        <p
                          style={{
                            fontSize: "15px",
                            color: "#1E2234",
                            height: 40,
                            boxSizing: "border-box",
                            wordBreak: "break-all"
                          }}
                        >
                          {getAllServiceProviderRate(row["service"])}
                        </p>
                      )}
                    </td>
                  ) : header.key === "nkRate" ? (
                    <td key={index} data-th={header.title} style={{}}>
                      {editCommission.edit &&
                      editCommission.currentIndex === i ? (
                        <CommissionEditComponent
                          onChange={(val) =>
                            dispatch(
                              commissionEditReducerSlice({
                                spr: editCommission?.spr,
                                nkrate: val,
                                resellerRate: editCommission?.resellerRate,
                                totalRate: editCommission.totalRate
                              })
                            )
                          }
                          value={editCommission.nkrate}
                        />
                      ) : (
                        <p>
                          {row["service"].map((service, i) => {
                            return (
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  cursor: "pointer"
                                }}
                              >
                                <p style={{}}>{service["neokredRate"] + "%"}</p>
                                {i + 1 < row["service"].length && <p>|</p>}
                              </div>
                            );
                          })}
                        </p>
                      )}
                    </td>
                  ) : header.key === "resellerRate" ? (
                    <td key={index} data-th={header.title} style={{}}>
                      {editCommission.edit &&
                      editCommission.currentIndex === i ? (
                        <CommissionEditComponent
                          onChange={(val) =>
                            dispatch(
                              commissionEditReducerSlice({
                                spr: editCommission.spr,
                                nkrate: editCommission.nkrate,
                                resellerRate: val,
                                totalRate: editCommission.totalRate
                              })
                            )
                          }
                          value={editCommission.resellerRate}
                        />
                      ) : (
                        <p>
                          {row["service"].map((service, i) => {
                            return (
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  cursor: "pointer"
                                }}
                              >
                                <p style={{}}>
                                  {service["resellerRate"] + "%"}
                                </p>
                                {i + 1 < row["service"].length && <p>|</p>}
                              </div>
                            );
                          })}
                        </p>
                      )}
                    </td>
                  ) : header.key === "clientStatus" ? (
                    <td key={index} data-th={header.title} style={{}}>
                      <p
                        style={{
                          background:
                            row[header.key] === "Active"
                              ? "rgba(63, 169, 47, 0.1)"
                              : "rgba(231, 66, 66, 0.1)",
                          color:
                            row[header.key] === "Active"
                              ? "#3FA92F"
                              : "#E74242",
                          borderRadius: "4px",
                          fontSize: "14px",
                          width: "75px",
                          height: 30,
                          justifyContent: "center",
                          alignItems: "center",
                          display: "flex"
                        }}
                      >
                        {row[header.key]}
                      </p>
                    </td>
                  ) : header.key === "beneName" ? (
                    <td key={index} data-th={header.title} style={{}}>
                      <p
                        style={{
                          borderRadius: "4px",
                          fontSize: "14px",
                          width: "120px",
                          height: 30
                        }}
                      >
                        {row["beneDetails"]?.name
                          ? row["beneDetails"]?.name
                          : "N/A"}
                      </p>
                    </td>
                  ) : header.key === "settlementStatus" ? (
                    <td key={index} data-th={header.title} style={{}}>
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <p
                          style={{
                            background:
                              row["status"] === "SETTLED"
                                ? colorLightGreen
                                : row["status"] === "INITIATED"
                                ? colorLightYellow
                                : colorLightRed,

                            color:
                              row["status"] === "SETTLED"
                                ? "#3FA92F"
                                : row["status"] === "INITIATED"
                                ? colorDarkYellow
                                : "#E74242",
                            borderRadius: "4px",
                            fontSize: "14px",
                            width: "75px",
                            height: 30,
                            justifyContent: "center",
                            alignItems: "center",
                            display: "flex"
                          }}
                        >
                          {row["status"] === "SETTLED"
                            ? "Settled"
                            : row["status"] === "INITIATED"
                            ? "INITIATED"
                            : "FAILED"}
                        </p>
                      </div>
                    </td>
                  ) : header.key === "createdBy" ? (
                    <td key={index} data-th={header.title} style={{}}>
                      <div style={{ display: "flex" }}>
                        <div
                          style={{
                            minWidth: "80px",
                            maxWidth: "80px"
                          }}
                        >
                          <p
                            style={{
                              fontSize: "16px",
                              color: "#1E2234"
                            }}
                          >
                            {moment(row["createdAt"]).format("DD MMM YY")}
                          </p>
                          <p
                            style={{
                              fontSize: "16px",
                              color: "#1E2234"
                            }}
                          >
                            {moment(row["createdAt"]).format("hh:mm A")}
                          </p>
                        </div>
                        <p>-</p>
                        <p
                          style={{
                            fontSize: "16px",
                            color: "#1E2234",
                            textTransform: "capitalize",
                            marginLeft: 2
                          }}
                        >
                          {row["createdBy"]?.["userName"]}
                        </p>
                      </div>
                    </td>
                  ) : header.key === "createdDate" ? (
                    <td key={index} data-th={header.title} style={{}}>
                      <p
                        style={{
                          fontSize: "16px"
                        }}
                      >
                        {moment(row["createdDate"]).format("DD-MM-YY")}
                      </p>
                      <p
                        style={{
                          fontSize: "14px"
                        }}
                      >
                        {moment(row["createdDate"]).format("hh:mm A")}
                      </p>
                    </td>
                  ) : header.key === "timestamp" ? (
                    <td key={index} data-th={header.title} style={{}}>
                      <p
                        style={{
                          fontSize: "16px"
                        }}
                      >
                        {moment(row["timestamp"]).format("DD-MM-YY")}
                      </p>
                      <p
                        style={{
                          fontSize: "14px"
                        }}
                      >
                        {moment(row["timestamp"]).format("hh:mm A")}
                      </p>
                    </td>
                  ) : header.key === "createdDateAt" ? (
                    <td key={index} data-th={header.title} style={{}}>
                      <p
                        style={{
                          fontSize: "16px"
                        }}
                      >
                        {moment(row["createdDate"]).format("DD-MM-YY")}
                      </p>
                      <p
                        style={{
                          fontSize: "14px"
                        }}
                      >
                        {moment(row["createdDate"]).format("hh:mm A")}
                      </p>
                    </td>
                  ) : header.key === "transaction_date" ? (
                    <td key={index} data-th={header.title} style={{}}>
                      <p
                        style={{
                          fontSize: "16px"
                        }}
                      >
                        {moment(row["created_at"]).format("DD-MM-YY")}
                      </p>
                      <p
                        style={{
                          fontSize: "14px"
                        }}
                      >
                        {moment(row["created_at"]).format("hh:mm A")}
                      </p>
                    </td>
                  ) : header.key === "created_at" ? (
                    <td key={index} data-th={header.title} style={{}}>
                      <p
                        style={{
                          fontSize: "16px"
                        }}
                      >
                        {moment(row["created_at"]).format("DD-MM-YY")}
                      </p>
                      <p
                        style={{
                          fontSize: "14px"
                        }}
                      >
                        {moment(row["created_at"]).format("hh:mm A")}
                      </p>
                    </td>
                  ) : header.key === "modified_date" ? (
                    <td key={index} data-th={header.title} style={{}}>
                      <p
                        style={{
                          fontSize: "16px"
                        }}
                      >
                        {moment(row["modified_at"]).format("DD-MM-YY")}
                      </p>
                      <p
                        style={{
                          fontSize: "14px"
                        }}
                      >
                        {moment(row["modified_at"]).format("hh:mm A")}
                      </p>
                    </td>
                  ) : header.key === "updatedAtOnly" ? (
                    <td key={index} data-th={header.title} style={{}}>
                      <div
                        style={{
                          display: "flex",
                          width: "180px"
                        }}
                      >
                        <div style={{ width: "90px" }}>
                          <p
                            style={{
                              fontSize: "16px"
                            }}
                          >
                            {moment(row["updatedAt"]).format("DD-MM-YY")}
                          </p>
                          <p
                            style={{
                              fontSize: "14px"
                            }}
                          >
                            {moment(row["updatedAt"]).format("hh:mm A")}
                          </p>
                        </div>
                      </div>
                    </td>
                  ) : header.key === "updatedAt" ? (
                    <td key={index} data-th={header.title} style={{}}>
                      <div
                        style={{
                          display: "flex",
                          width: "180px"
                        }}
                      >
                        <div style={{ width: "90px" }}>
                          <p
                            style={{
                              fontSize: "16px"
                            }}
                          >
                            {moment(row["createdAt"]).format("DD-MM-YY")}
                          </p>
                          <p
                            style={{
                              fontSize: "14px"
                            }}
                          >
                            {moment(row["createdAt"]).format("hh:mm A")}
                          </p>
                        </div>
                        -
                        <p style={{ marginLeft: "5px" }}>
                          {row["approvedBy"]?.userName
                            ? row["approvedBy"]?.userName
                            : "N/A"}{" "}
                        </p>
                      </div>
                    </td>
                  ) : header.key === "resellerUpdatedDate" ? (
                    <td key={index} data-th={header.title} style={{}}>
                      <p
                        style={{
                          fontSize: "16px"
                        }}
                      >
                        {moment(row["createdAt"]).format("DD-MM-YY")}
                      </p>
                      <p
                        style={{
                          fontSize: "14px"
                        }}
                      >
                        {moment(row["createdAt"]).format("hh:mm A")}
                      </p>
                    </td>
                  ) : header.key === "revenueCreatedAt" ? (
                    <td key={index} data-th={header.title} style={{}}>
                      <p
                        style={{
                          fontSize: "16px"
                        }}
                      >
                        {moment(row["createdAt"]).format("DD-MM-YY")}
                      </p>
                      <p
                        style={{
                          fontSize: "14px"
                        }}
                      >
                        {moment(row["createdAt"]).format("hh:mm A")}
                      </p>
                    </td>
                  ) : header.key === "settleMentCreatedAt" ? (
                    <td key={index} data-th={header.title} style={{}}>
                      <p
                        style={{
                          fontSize: "16px"
                        }}
                      >
                        {moment(row["createdAt"]).format("DD-MM-YY")}
                      </p>
                      <p
                        style={{
                          fontSize: "14px"
                        }}
                      >
                        {moment(row["createdAt"]).format("hh:mm A")}
                      </p>
                    </td>
                  ) : header.key === "settlementStartAndEndDate" ? (
                    <td
                      key={index}
                      data-th={header.title}
                      style={
                        {
                          // display: "flex",
                          // flexDirection: "row",
                          // width: 200,
                        }
                      }
                    >
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          width: 200
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            fontSize: "15px"
                          }}
                        >
                          <p>
                            {moment.utc(row["startDate"]).format("DD-MM-YY")}
                          </p>
                          <p>
                            {moment.utc(row["startDate"]).format("hh:mm A")}
                          </p>
                        </div>
                        <span
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                            paddingRight: 5,
                            paddingLeft: 5
                          }}
                        >
                          -
                        </span>
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            fontSize: "15px"
                          }}
                        >
                          <p>{moment.utc(row["endDate"]).format("DD-MM-YY")}</p>
                          <p>{moment.utc(row["endDate"]).format("hh:mm A")}</p>
                        </div>
                      </div>
                    </td>
                  ) : header.key === "revenueStartAndEndDate" ? (
                    <td
                      key={index}
                      data-th={header.title}
                      style={
                        {
                          // display: "flex",
                          // flexDirection: "row",
                          // width: 200,
                        }
                      }
                    >
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          width: 200
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            fontSize: "15px"
                          }}
                        >
                          <p>
                            {moment.utc(row["startDate"]).format("DD-MM-YY")}
                          </p>
                          <p>
                            {moment.utc(row["startDate"]).format("hh:mm A")}
                          </p>
                        </div>
                        <span
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                            paddingRight: 5,
                            paddingLeft: 5
                          }}
                        >
                          -
                        </span>
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            fontSize: "15px"
                          }}
                        >
                          <p>{moment.utc(row["endDate"]).format("DD-MM-YY")}</p>
                          <p>{moment.utc(row["endDate"]).format("hh:mm A")}</p>
                        </div>
                      </div>
                    </td>
                  ) : header.key === "rejectedDate" ? (
                    <td key={index} data-th={header.title} style={{}}>
                      <p
                        style={{
                          fontSize: "16px"
                        }}
                      >
                        {moment(row["rejectedBy"]?.rejectedDate).format(
                          "DD-MM-YY"
                        )}
                      </p>
                      <p
                        style={{
                          fontSize: "14px"
                        }}
                      >
                        {moment(row["rejectedBy"]?.rejectedDate).format(
                          "hh:mm A"
                        )}
                      </p>
                    </td>
                  ) : header.key === "toggleStatus" ? (
                    <td key={index} data-th={header.title} style={{}}>
                      {aclData.includes(CLIENTS_DEACTIVATE_ACCOUNT_ACL) ? (
                        <ToggleSwitch
                          checked={
                            row["activeStatus"] !== INACTIVE ? true : false
                          }
                          status={row["activeStatus"]}
                          onChange={() => {
                            if (row["activeStatus"] === PENDING) {
                            } else onStatusChange(row);
                          }}
                          style={{
                            pointerEvents:
                              row["activeStatus"] === PENDING ? "none" : "all",
                            cursor:
                              row["activeStatus"] === PENDING
                                ? "not-allowed"
                                : "pointer"
                          }}
                          id={index}
                        />
                      ) : (
                        <div
                          style={{
                            backgroundColor:
                              row["activeStatus"] === ACTIVE
                                ? colorLightGreen
                                : row["activeStatus"] === INACTIVE
                                ? colorLightRed
                                : colorLightYellow,
                            color:
                              row["activeStatus"] === ACTIVE
                                ? colorDarkGreen
                                : row["activeStatus"] === INACTIVE
                                ? colorDarkRed
                                : colorDarkYellow,
                            padding: "10px 10px",
                            textAlign: "center",
                            borderRadius: 5
                          }}
                        >
                          <p>
                            {row["activeStatus"] === ACTIVE
                              ? "Active"
                              : row["activeStatus"] === INACTIVE
                              ? "IN-Active"
                              : "Pending"}
                          </p>
                        </div>
                      )}
                    </td>
                  ) : header.key === "toggleStatusReseller" ? (
                    <td key={index} data-th={header.title} style={{}}>
                      {aclData.includes(RESELLER_DEACTIVATE_ACL) ? (
                        <ToggleSwitch
                          checked={row["isEnabled"]}
                          onChange={() => onStatusChange(row)}
                        />
                      ) : (
                        <div
                          style={{
                            backgroundColor: row["isEnabled"]
                              ? colorLightGreen
                              : colorLightRed,
                            color: row["isEnabled"]
                              ? colorDarkGreen
                              : colorDarkRed,
                            padding: "10px 10px",
                            textAlign: "center",
                            borderRadius: 5
                          }}
                        >
                          <p>{row["isEnabled"] ? "Active" : "IN-Active"}</p>
                        </div>
                      )}
                    </td>
                  ) : header.key === "toggleStatusRisk" ? (
                    <td key={index} data-th={header.title} style={{}}>
                      {aclData.includes(CUSTOMER_STATUS_EDIT) ? (
                        <ToggleSwitch
                          checked={row["status"]}
                          onChange={() => onStatusChange(row)}
                        />
                      ) : (
                        <div
                          style={{
                            backgroundColor: row["status"]
                              ? colorLightGreen
                              : colorLightRed,
                            color: row["status"]
                              ? colorDarkGreen
                              : colorDarkRed,
                            padding: "10px 10px",
                            textAlign: "center",
                            borderRadius: 5
                          }}
                        >
                          <p>{row["status"] ? "Active" : "IN-Active"}</p>
                        </div>
                      )}
                    </td>
                  ) : header.key === "deactivatedBy" ? (
                    <td key={index} data-th={header.title} style={{}}>
                      <ToggleSwitch
                        checked={row["deactivatedBy"]?.userName}
                        onChange={() => onStatusChange(row)}
                      />
                    </td>
                  ) : header.key === "showStatus" ? (
                    <td key={index} data-th={header.title} style={{}}>
                      <div
                        style={{
                          backgroundColor: row["isEnabled"]
                            ? colorLightGreen
                            : colorLightRed,
                          color: row["isEnabled"]
                            ? colorDarkGreen
                            : colorDarkRed,
                          padding: "10px 10px",
                          textAlign: "center",
                          borderRadius: 5
                        }}
                      >
                        <p>{row["isEnabled"] ? "Active" : "In-Active"}</p>
                      </div>
                    </td>
                  ) : header.key === "deactivatedDetails" ? (
                    <td key={index} data-th={header.title} style={{}}>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center"
                        }}
                      >
                        <p>
                          {row["deactivatedBy"]?.userName
                            ? row["deactivatedBy"]?.userName
                            : "N/A"}
                        </p>

                        <div
                          className="tooltip"
                          style={{ display: "flex", alignItems: "center" }}
                        >
                          <InfoTextIcon
                            style={{ width: "20px", height: "20px" }}
                            className="tooltip"
                          />
                          <span className="tooltiptext">
                            {row["deactivatedBy"]?.reason
                              ? row["deactivatedBy"]?.reason
                              : "Client Deactivated"}
                          </span>
                        </div>
                      </div>
                    </td>
                  ) : header.key === "rejectedDetails" ? (
                    <td key={index} data-th={header.title} style={{}}>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center"
                        }}
                      >
                        <p>
                          {role === ADMIN_USER ||
                          (role === SALES && row["rejectedBy"]?.userName)
                            ? row["rejectedBy"]?.userName
                            : "N/A"}
                        </p>

                        <div
                          className="tooltip"
                          style={{ display: "flex", alignItems: "center" }}
                        >
                          <InfoTextIcon
                            style={{ width: "20px", height: "20px" }}
                            className="tooltip"
                          />
                          <span className="tooltiptext">
                            {row["rejectedBy"]?.reason
                              ? row["rejectedBy"]?.reason
                              : "Client Rejected"}
                          </span>
                        </div>
                      </div>
                    </td>
                  ) : header.key === "action" ? (
                    <td key={index} data-th={header.title} style={{}}>
                      <p
                        style={{
                          background: "rgba(111, 108, 255, 0.1)",
                          color: "#38369C",
                          borderRadius: "4px",
                          fontSize: "14px",
                          //width: "100%",
                          // margin: "auto",
                          height: 30,
                          padding: "6px 8px",
                          cursor: "pointer",
                          maxWidth: "110px",
                          textAlign: "center"
                        }}
                        onClick={() => onViewMore(row)}
                      >
                        {"View more"}
                      </p>
                    </td>
                  ) : header.key === "intent" ? (
                    <td key={index} data-th={header.title} style={{}}>
                      <p
                        style={{
                          background: "rgba(111, 108, 255, 0.1)",
                          color: "#38369C",
                          borderRadius: "4px",
                          fontSize: "14px",
                          //width: "100%",
                          // margin: "auto",
                          height: 30,
                          padding: "6px 8px",
                          cursor: "pointer",
                          maxWidth: "110px",
                          textAlign: "center"
                        }}
                        onClick={() => onQrCreate(true, row)}
                      >
                        {"Create Intent"}
                      </p>
                    </td>
                  ) : header.key === "approve" ? (
                    <td key={index} data-th={header.title} style={{}}>
                      {row.action === "" &&
                      row.serviceProviderName?.toLowerCase() === "fino" ? (
                        <select
                          value={selectedOptions[index] || ""}
                          onChange={(e) => {
                            onActionClicked({
                              action: e.target.value,
                              trans: row
                            });
                          }}
                          style={{
                            background: "#F9F9FB",
                            color: "#7181A1",
                            borderRadius: "18px",
                            fontSize: "14px",
                            fontWeight: 500,
                            height: 30,
                            padding: "6px 8px",
                            cursor: "pointer",
                            maxWidth: "110px",
                            textAlign: "center"
                          }}
                        >
                          {options.map((option) => (
                            <option key={option.value} value={option.value}>
                              {option.label}
                            </option>
                          ))}
                        </select>
                      ) : row.serviceProviderName &&
                        row.serviceProviderName?.toLowerCase() !== "fino" ? (
                        <p>-</p>
                      ) : (
                        <div
                          style={{
                            height: "30px",
                            width: "72px",
                            textAlign: "center",
                            background:
                              row.action === "approve"
                                ? "#E6FAF1"
                                : row.action === "reject"
                                ? "#FFC1BC"
                                : "",
                            borderRadius: "18px",
                            fontSize: "12px",
                            alignItems: "center",
                            paddingTop: "4px",
                            color:
                              row.action === "approve"
                                ? "#009152"
                                : row.action === "reject"
                                ? "#B34840"
                                : ""
                          }}
                        >
                          {row.action === "approve" &&
                          row.serviceProviderName?.toLowerCase() === "fino"
                            ? "Approved"
                            : row.action === "reject" &&
                              row.serviceProviderName?.toLowerCase() === "fino"
                            ? "Rejected"
                            : ""}
                        </div>
                      )}
                    </td>
                  ) : header.key === "prefundAction" ? (
                    <td key={index} data-th={header.title} style={{}}>
                      {/* <p
                        style={{
                          background: "rgba(111, 108, 255, 0.1)",
                          color: "#38369C",
                          borderRadius: "4px",
                          fontSize: "14px",
                          width: "100%",
                          margin: "auto",
                          height: 30,
                          padding: "6px 8px",
                          cursor: "pointer",
                          maxWidth: "110px",
                          textAlign: "center",
                        }}
                        onClick={() => onViewMore(row)}
                      >
                        {"View more"}
                      </p> */}

                      {row["requestedPrefund"] &&
                      row["status"] === "INITIATED" ? (
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: 10
                          }}
                        >
                          <Reject
                            style={{ cursor: "pointer" }}
                            onClick={() => onClickReject(row)}
                          />
                          <Approve
                            style={{ cursor: "pointer" }}
                            onClick={() => onClickAccept(row)}
                          />

                          <Eyelight
                            style={{
                              minWidth: 24,
                              height: 24,
                              cursor: "pointer"
                            }}
                            onClick={() => {
                              saveAs(row["paymentSlip"], "PaymentSlip.png");
                            }}
                          />
                        </div>
                      ) : row["requestedPrefund"] ? (
                        <Eyelight
                          style={{
                            minWidth: 24,
                            height: 24,
                            cursor: "pointer"
                          }}
                          onClick={() => {
                            saveAs(row["paymentSlip"], "PaymentSlip.png");
                          }}
                        />
                      ) : (
                        "-"
                      )}
                    </td>
                  ) : header.key === "SID" ? (
                    <td key={index} data-th={header.title} style={{}}>
                      <div
                        style={{
                          background: "#38369C",
                          color: "white",
                          borderRadius: "4px",
                          fontSize: "14px",
                          width: "100px",
                          height: 30,
                          justifyContent: "center",
                          padding: "6px 8px",
                          alignItems: "center",
                          display: "flex",
                          cursor: "pointer",
                          maxWidth: "110px"
                        }}
                        onClick={() => {
                          onViewMore(row);
                        }}
                      >
                        {"Enter SID"}
                      </div>
                    </td>
                  ) : header.key === "commissionAction" ? (
                    <td key={index} data-th={header.title} style={{}}>
                      {editCommission.edit &&
                      editCommission.currentIndex === i ? (
                        <div style={{ display: "flex", alignItems: "center" }}>
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              width: 32,
                              height: 32,
                              backgroundColor: "rgba(231, 66, 66, 0.1)",
                              borderRadius: "28px",
                              cursor: "pointer",
                              marginLeft: "15px"
                            }}
                            onClick={() => {
                              dispatch(
                                commissionReducerSlice({
                                  edit: false,
                                  index: null
                                })
                              );
                              dispatch(
                                commissionEditReducerSlice({
                                  spr: 0,
                                  nkrate: 0,
                                  resellerRate: 0,
                                  totalRate: 0
                                })
                              );
                            }}
                          >
                            <CgClose color="#E74242" size={15} />
                          </div>
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              width: 32,
                              height: 32,
                              backgroundColor: "rgba(63, 169, 47, 0.1)",
                              marginLeft: 16,
                              borderRadius: "28px",
                              cursor: "pointer"
                            }}
                            onClick={() => {
                              dispatch(
                                commissionReducerSlice({
                                  edit: false,
                                  index: null
                                })
                              );
                              dispatch(
                                commissionEditReducerSlice({
                                  spr: 0,
                                  nkrate: 0,
                                  resellerRate: 0,
                                  totalRate: 0
                                })
                              );
                            }}
                          >
                            <TbCheck color="#3FA92F" size={15} />
                          </div>
                        </div>
                      ) : (
                        <div style={{ display: "flex", alignItems: "center" }}>
                          <p
                            style={{
                              background: "rgba(63, 169, 47, 0.1)",
                              color: "#3FA92F",
                              borderRadius: "4px",
                              fontSize: "14px",
                              justifyContent: "center",
                              padding: "6px 8px",
                              alignItems: "center",
                              display: "flex",
                              cursor: "pointer",
                              maxWidth: "80px"
                            }}
                            onClick={() => onViewMore(row)}
                          >
                            {"Active"}
                          </p>
                          <div
                            style={{
                              width: "32px",
                              height: "32px",
                              borderRadius: "20px",
                              backgroundColor: "rgba(56, 54, 156, 0.1)",
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              marginLeft: 8,
                              cursor: "pointer"
                            }}
                            onClick={() => {
                              dispatch(
                                commissionReducerSlice({ edit: true, index: i })
                              );
                              dispatch(
                                commissionEditReducerSlice({
                                  spr: row["spr"],
                                  nkrate: row["nkRate"],
                                  resellerRate: row["resellerRate"],
                                  totalRate: row["tcr"]
                                })
                              );
                            }}
                          >
                            <EditAltIcon />
                          </div>
                        </div>
                      )}
                    </td>
                  ) : header.key === "mainAction" ? (
                    aclData.includes(APPROVAL_LIST) ? (
                      <td
                        key={index}
                        data-th={header.title}
                        // style={{ width: "fit-conent", margin: "auto" }}
                      >
                        <div style={{ display: "flex", alignItems: "center" }}>
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              width: 32,
                              height: 32,
                              backgroundColor: "rgba(231, 66, 66, 0.1)",
                              borderRadius: "28px",
                              cursor: "pointer",
                              marginLeft: "15px",
                              pointerEvents: loading1 ? "none" : "all"
                            }}
                            onClick={() => {
                              onClickReject(row);
                            }}
                          >
                            <CgClose color="#E74242" size={15} />
                          </div>

                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              backgroundColor: "rgba(63, 169, 47, 0.1)",
                              marginLeft: 16,
                              borderRadius: "5px",
                              cursor: "pointer",
                              padding: "8px 15px",
                              pointerEvents: loading1 ? "none" : "all"
                            }}
                            onClick={() => {
                              onClickAccept(row);
                            }}
                          >
                            <p
                              style={{
                                color: colorDarkGreen,
                                fontSize: loading1 ? 10 : 12
                              }}
                            >
                              {loading1 ? "loading..." : "Approve"}
                            </p>
                          </div>
                        </div>
                      </td>
                    ) : (
                      <td key={index} data-th={header.title} style={{}}>
                        <p
                          style={{
                            background: "rgba(111, 108, 255, 0.1)",
                            color: "#38369C",
                            borderRadius: "4px",
                            fontSize: "14px",
                            width: "100px",
                            height: 30,
                            justifyContent: "center",
                            padding: "6px 8px",
                            alignItems: "center",
                            display: "flex",
                            cursor: "pointer",
                            maxWidth: "110px"
                          }}
                          onClick={() => onViewMore(row)}
                        >
                          {"View more"}
                        </p>
                      </td>
                    )
                  ) : header.key === "comissionRate" ? (
                    <td key={index} data-th={header.title} style={{}}>
                      {row["service"]?.length > 0 &&
                        row["service"].map((service, i) => {
                          return service["comissionType"] === "SLAB" ? (
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                cursor: "pointer"
                              }}
                              onClick={() =>
                                onViewMoreCommission(service["comissionRate"])
                              }
                              key={i}
                            >
                              <p style={{}}>
                                {service["comissionRate"][0]?.from +
                                  "-" +
                                  service["comissionRate"][0]?.to}
                                {" / "}
                                {service["comissionRate"][0]?.type ===
                                "PERCENTAGE"
                                  ? "%"
                                  : "₹"}
                                {service["comissionRate"][0]?.value}
                              </p>
                              <FiChevronDown
                                color={primaryColor}
                                size={24}
                                style={{}}
                              />
                            </div>
                          ) : (
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                cursor: "pointer"
                              }}
                              key={i}
                            >
                              <p style={{}}>
                                {service["comissionRate"].length > 0 &&
                                  (service["comissionRate"][0]?.type ===
                                  "PERCENTAGE"
                                    ? service["comissionRate"][0]?.value + "%"
                                    : "₹" + service["comissionRate"][0]?.value)}
                              </p>
                              {i + 1 < row["service"].length && <p>|</p>}
                            </div>
                          );
                        })}
                    </td>
                  ) : header.key === "resellerCommissionRate" ? (
                    <td key={index} data-th={header.title} style={{}}>
                      {row["comissionType"] === "SLAB" ? (
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            cursor: "pointer"
                          }}
                          onClick={() =>
                            onViewMoreCommission(row["comissionRate"])
                          }
                        >
                          <p style={{}}>
                            {row["comissionRate"][0]?.from +
                              "-" +
                              row["comissionRate"][0]?.to}
                            {" / "}
                            {row["comissionRate"][0]?.type === "PERCENTAGE"
                              ? "%"
                              : "₹"}
                            {row["comissionRate"][0]?.value}
                          </p>
                          <FiChevronDown
                            color={primaryColor}
                            size={24}
                            style={{}}
                          />
                        </div>
                      ) : (
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            cursor: "pointer"
                          }}
                          // onClick={() =>
                          //   onViewMoreCommission(service["comissionRate"])
                          // }
                          // key={i}
                        >
                          <p style={{}}>
                            {row["comissionRate"].length > 0 &&
                              (row["comissionRate"][0]?.type === "PERCENTAGE"
                                ? row["comissionRate"][0]?.value + "%"
                                : "₹" + row["comissionRate"][0]?.value)}
                          </p>
                        </div>
                      )}
                    </td>
                  ) : header.key === "name" ? (
                    <td key={index} data-th={header.title} style={{}}>
                      <p
                        style={{
                          color: "#0983DB",
                          textTransform: "capitalize",
                          cursor: "pointer"
                        }}
                        onClick={() => onViewMore(row)}
                      >
                        {row?.firstName + " " + row?.lastName}
                      </p>
                    </td>
                  ) : header.key === "name" ? (
                    <td key={index} data-th={header.title} style={{}}>
                      <p
                        style={{
                          color: "#0983DB",
                          textTransform: "capitalize",
                          cursor: "pointer"
                        }}
                        onClick={() => onViewMore(row)}
                      >
                        {row?.firstName + " " + row?.lastName}
                      </p>
                    </td>
                  ) : header.key === "kopay_cid" ? (
                    <td key={index} data-th={header.title} style={{}}>
                      <p style={{}}>
                        {row?.programs?.[0]?.kopay_cid
                          ? row?.programs?.[0]?.kopay_cid
                          : "N/A"}
                      </p>
                    </td>
                  ) : header.key === "transactionClientUpi" ? (
                    <td key={index} data-th={header.title} style={{}}>
                      <p style={{}}>{row?.upi_id ? row?.upi_id : "N/A"}</p>
                    </td>
                  ) : header.key === "transactionClientPayinUpi" ? (
                    <td key={index} data-th={header.title} style={{}}>
                      <p style={{}}>{row?.customerInfo?.upiId ?? "N/A"}</p>
                    </td>
                  ) : header.key === "spName" ? (
                    <td key={index} data-th={header.title} style={{}}>
                      <p style={{}}>
                        {getAllServiceName(row?.service, internal)}
                      </p>
                    </td>
                  ) : header.key === "bankUTRNo" ? (
                    <td key={index} data-th={header.title} style={{}}>
                      <p style={{}}>{row?.custRefNo ?? "N/A"}</p>
                    </td>
                  ) : header.key === "serviceType" ? (
                    <td key={index} data-th={header.title} style={{}}>
                      <p style={{}}>
                        {internal
                          ? row?.service?.length > 0
                            ? row.service.map((s) => s.serviceType).join(", ")
                            : ""
                          : "van"}
                        {}
                      </p>
                    </td>
                  ) : header.key === "financeServiceType" ? (
                    <td key={index} data-th={header.title} style={{}}>
                      <p style={{}}>{row?.serviceType}</p>
                    </td>
                  ) : header.key === "clientRate" ? (
                    <td key={index} data-th={header.title} style={{}}>
                      <p style={{}}>
                        {row["service"]?.length > 0 &&
                          row["service"].map((service, i) => {
                            return service["comissionType"] === "SLAB" ? (
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  cursor: "pointer"
                                }}
                                onClick={() =>
                                  onViewMoreCommission(service["comissionRate"])
                                }
                              >
                                <p style={{}}>
                                  {service["comissionRate"][0]?.from +
                                    "-" +
                                    service["comissionRate"][0]?.to}
                                  {" / "}
                                  {service["comissionRate"][0]?.type ===
                                  "PERCENTAGE"
                                    ? "%"
                                    : "₹"}
                                  {service["comissionRate"][0]?.value}
                                </p>
                                <FiChevronDown
                                  color={primaryColor}
                                  size={24}
                                  style={{}}
                                />
                              </div>
                            ) : (
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  cursor: "pointer"
                                }}
                              >
                                <p style={{}}>
                                  {service["comissionRate"].length > 0 &&
                                    (service["comissionRate"][0]?.type ===
                                    "PERCENTAGE"
                                      ? service["comissionRate"][0]?.value + "%"
                                      : "₹" +
                                        service["comissionRate"][0]?.value)}
                                </p>
                                {i + 1 < row["service"].length && <p>|</p>}
                              </div>
                            );
                          })}
                      </p>
                    </td>
                  ) : header.key === "txn_final_amount" ? (
                    <td key={index} data-th={header.title} style={{}}>
                      <p style={{}}>
                        {row["status"] === TRANSACTION_CREDITED ||
                        row["status"] === TRANSACTION_DEBITED ||
                        row["status"] === TRANSACTION_CREDIT
                          ? "₹" + formatBalance(Number(row["final_amount"]))
                          : "₹" + formatBalance(Number(row["actual_amount"]))}
                      </p>
                    </td>
                  ) : header.key === "totalTransferAmount" ? (
                    <td key={index} data-th={header.title} style={{}}>
                      <p style={{}}>
                        {"₹" +
                          formatBalance(Number(row["totalTransferAmount"]))}
                      </p>
                    </td>
                  ) : header.key === "actual_amount" ? (
                    <td key={index} data-th={header.title} style={{}}>
                      <p style={{}}>
                        {row["status"] === "CREDITED" ||
                        row["status"] === "DEEMED"
                          ? "₹" + formatBalance(Number(row["final_amount"]))
                          : "₹" + formatBalance(Number(row["actual_amount"]))}
                        {/* {"₹" + formatBalance(Number(row["actual_amount"]))} */}
                      </p>
                    </td>
                  ) : header.key === "van_actual_amount" ? (
                    <td key={index} data-th={header.title} style={{}}>
                      <p style={{}}>
                        {row["status"] === "CREDITED" ||
                        row["status"] === "DEEMED"
                          ? "₹" + formatBalance(Number(row["actual_amount"]))
                          : "₹" + formatBalance(Number(row["actual_amount"]))}
                      </p>
                    </td>
                  ) : header.key === "commissionAmount" ? (
                    <td key={index} data-th={header.title} style={{}}>
                      <p style={{}}>
                        {row["status"] === TRANSACTION_CREDITED ||
                        row["status"] === TRANSACTION_DEBITED
                          ? "₹" + formatBalance(Number(row["commissionAmount"]))
                          : 0}
                      </p>
                    </td>
                  ) : header.key === "rollingReserves" ? (
                    <td key={index} data-th={header.title} style={{}}>
                      <p style={{}}>
                        {"₹" + formatBalance(Number(row["reserves"])) ?? 0}
                      </p>
                    </td>
                  ) : header.key === "commissionGst" ? (
                    <td key={index} data-th={header.title} style={{}}>
                      <p style={{}}>
                        {row["status"] === TRANSACTION_CREDITED ||
                        row["status"] === TRANSACTION_DEBITED
                          ? "₹" + formatBalance(Number(row["commissionGst"]))
                          : 0}
                      </p>
                    </td>
                  ) : header.key === "totalCommissionAmount" ? (
                    <td key={index} data-th={header.title} style={{}}>
                      <p style={{}}>
                        {"₹" +
                          formatBalance(
                            Number(row["totalCommissionAmount"]) +
                              Number(row["totalCommissionGst"])
                          )}
                      </p>
                    </td>
                  ) : header.key === "totalActualAmount" ? (
                    <td key={index} data-th={header.title} style={{}}>
                      <p style={{}}>
                        {"₹" + formatBalance(Number(row["totalActualAmount"]))}
                      </p>
                    </td>
                  ) : header.key === "totalCommissionGst" ? (
                    <td key={index} data-th={header.title} style={{}}>
                      <p style={{}}>
                        {"₹" + formatBalance(Number(row["totalCommissionGst"]))}
                      </p>
                    </td>
                  ) : header.key === "totalActualAmount" ? (
                    <td key={index} data-th={header.title} style={{}}>
                      <p style={{}}>
                        {"₹" + formatBalance(Number(row["totalActualAmount"]))}
                      </p>
                    </td>
                  ) : header.key === "clientActiveStatus" ? (
                    <td key={index} data-th={header.title} style={{}}>
                      <p
                        style={{
                          background:
                            row["activeStatus"] === "ACTIVE"
                              ? "rgba(63, 169, 47, 0.1)"
                              : "rgba(231, 66, 66, 0.1)",
                          color:
                            row["activeStatus"] === "ACTIVE"
                              ? "#3FA92F"
                              : "#E74242",
                          borderRadius: "4px",
                          fontSize: "14px",
                          width: "75px",
                          height: 30,
                          justifyContent: "center",
                          alignItems: "center",
                          display: "flex",
                          textTransform: "capitalize"
                        }}
                      >
                        {row["activeStatus"] === "ACTIVE"
                          ? "Active"
                          : "Inactive"}
                      </p>
                    </td>
                  ) : header.key === "businessName" ? (
                    <td key={index} data-th={header.title}>
                      {row[header.key] ? row[header.key] : "N/A"}
                    </td>
                  ) : header.key === "userActions" ? (
                    <td
                      key={index}
                      data-th={header.title}
                      style={{ display: "flex", flexDirection: "row" }}
                    >
                      {aclData.includes(ROLE_Deactivate_ACL) && (
                        <ToggleSwitch
                          checked={row["status"]}
                          status={row["status"]}
                          onChange={() => {
                            if (row["activeStatus"] === PENDING) {
                            } else onStatusChange(row);
                          }}
                          style={{
                            marginTop: "5px",
                            marginRight: "8px",
                            cursor: "pointer"
                          }}
                          id={index}
                        />
                      )}

                      <p
                        style={{
                          background: "rgba(111, 108, 255, 0.1)",
                          color: "#38369C",
                          borderRadius: "4px",
                          fontSize: "14px",
                          width: "100px",
                          height: 30,
                          justifyContent: "center",
                          padding: "6px 8px",
                          alignItems: "center",
                          display: "flex",
                          cursor: "pointer",
                          maxWidth: "110px"
                        }}
                        onClick={() => onViewMore(row)}
                      >
                        {"View more"}
                      </p>
                    </td>
                  ) : (
                    <td key={index} data-th={header.title}>
                      {header.key === "mobileNumber"
                        ? "+91 " + row[header.key]
                        : row[header.key]
                        ? row[header.key]
                        : "N/A"}
                    </td>
                  )
                )}
              </tr>
            ))}
        </tbody>
      </table>

      {data && !isTableLoading && data?.length === 0 && (
        <div
          style={{
            width: "100%",
            height: height * 0.7,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
            position: "sticky",
            top: 0,
            left: 0
          }}
        >
          {/* <NoTransaction_Icon /> */}
          <p style={{ color: "#8483B4", marginTop: 10 }}>{emptyDataMessage}</p>
        </div>
      )}

      {isTableLoading && (
        <div
          style={{
            width: "100%",
            height: height * 0.7,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column"
          }}
        >
          <CustomLoader size={"50px"} />
        </div>
      )}

      <div
        className="pagination"
        style={{
          width: "100%",
          position: "sticky",
          bottom: -1,
          left: 0,
          zIndex: 4
        }}
      >
        <Pagination
          className="pagination-bar"
          currentPage={currentPage + 1}
          totalCount={totalElements}
          pageSize={10}
          onPageChange={(page) => {
            handlePaginate(page - 1);
            setIndexing(page - 1);
          }}
          totalPages={totalPages}
        />
      </div>
    </div>
  );
};

export default CustomTable;
